import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderService } from '@core/services/loader.service';
import { MessageService } from 'primeng/api';
import { ConfigPresorteo } from '../../../models/config-pesorteo.model';
import { ConfigPresorteoService } from '../../../services/configPresorteo/config-presorteo.service';

@Component({
    selector: 'app-config-presorteo-edit',
    templateUrl: './config-presorteo-edit.component.html',
    styleUrls: ['./config-presorteo-edit.component.scss']
})
export class ConfigPresorteoEditComponent implements OnInit {

    @Input() config: ConfigPresorteo;
    @Input() type: 'create' | 'edit' | 'form' = 'create';
    private _form: FormGroup;
    statusOpt: {
        name: string,
        value: string
    }[] = [
            {
                name: 'Activo',
                value: 'enabled'
            },
            {
                name: 'Inactivo',
                value: 'disabled'
            },
        ];
    constructor(
        private fb: FormBuilder,
        private router: Router,
        private loadService: LoaderService,
        private messageService: MessageService,
        private configPresorteoService: ConfigPresorteoService
    ) {

    }

    ngOnInit(): void {
        this.initForm();
        if (this.type === 'edit') {
            if (this.config.status === 'enabled') {
                this._form.get('status').setValue('enabled');
            } else {
                this._form.get('status').setValue('disabled');
            }

        }
    }

    initForm() {
        this._form = this.fb.group({
            id: [this.config?.id || ''],
            configSets: this.fb.group({
                id: [this.config?.configSets?.id || ''],
                description: [this.config?.configSets?.description || '', Validators.required],
                inicialN: [this.config?.configSets?.inicialN || '', Validators.required],
                finalN: [this.config?.configSets?.finalN || '', Validators.required]
            }),
            urlGna: [this.config?.urlGna || 'http://localhost:3000'],
            status: ['', [Validators.required]]
        });
    }

    get form(): FormGroup {
        return this._form;
    }

    get formRaw(): ConfigPresorteo {
        return this._form.getRawValue();
    }

    get valid(): boolean {
        return this._form.valid;
    }

    complete() {
        this.loadService.show();
        if (this.type == 'create') {
            this.configPresorteoService.postConfigPresorteo(this.formRaw)
                .then(response => {
                    if (response.success) {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Hecho',
                            detail: 'Cambio realizado con éxito',
                            key: 'config'
                        });
                        setTimeout(() => {
                            this.router.navigate(['presorteo/megaloto/config-presorteo']);
                        }, 1500);
                    }
                })
                .finally(() => {
                    this.loadService.hide();
                });
        } else if (this.type == 'edit') {
            this.configPresorteoService.putConfigPresorteo(this.formRaw)
                .then(response => {
                    if (response.success) {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Hecho',
                            detail: 'Cambio realizado con éxito',
                            key: 'config'
                        });
                        setTimeout(() => {
                            this.router.navigate(['presorteo/megaloto/config-presorteo']);
                        }, 1500);
                    }
                })
                .finally(() => {
                    this.loadService.hide();
                });
        }

    }

}
